import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetItemQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetItemQuery = { __typename?: 'Query', item?: { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, attributes: { __typename?: 'ItemAttributesData', addedShippingUomIds: Array<string>, defaultShippingUomId?: string | null, isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> }, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }> } | null };

export type GetItemDiscountableQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetItemDiscountableQuery = { __typename?: 'Query', item?: { __typename?: 'ItemStateData', attributes: { __typename?: 'ItemAttributesData', discountable: boolean } } | null };

export type GetItemsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeCombined?: Types.Scalars['Boolean']['input'];
}>;


export type GetItemsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', incomeGlAccountId?: string | null, absorbedItemIds: Array<string>, absorbedSkus: Array<string>, absorbedUpcs: Array<string>, absorbedErpIds: Array<string>, absorbedLookupCodes: Array<string>, formerNames: Array<string>, combinedIntoItemId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, batchTracked: boolean, id: string, tenantId: string, itemId: string, name: string, sku: string, upc: string, retailPrice?: number | null, cogs?: number | null, status: Types.ItemStatus, description: string, categories?: Array<string> | null, sortCategory?: string | null, history: Array<string>, group: string, erpId: string, availableQuantity?: number | null, genus: string, productGroup: string, isOrganic: boolean, native: boolean, stripeTaxCode?: string | null, usageCount?: number | null, usedForRetail: boolean, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, defaultCarrier?: string | null, defaultShippingConfigCategoryCode?: string | null, shippingConfigCategoryCodes: Array<string>, effectiveShippingUomId?: string | null, inheritedShippingUomIds: Array<string>, availableShippingUomIds: Array<string>, shippingIncrement?: number | null, itemLookupCode: string, taxable: boolean, commissionable: boolean, discountable: boolean, effectiveEachesPerUnit?: number | null, effectiveShippingUomSource: Types.ShippingUomSource, incomeGlAccount?: { __typename?: 'MergeDevAccountDocument', accountNumber: string, name: string } | null, characteristics: Array<{ __typename?: 'ItemCharacteristicPickDocument', itemCharacteristicId: string, valueId: string }>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, substitution?: { __typename?: 'SubstitutionDocument', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfigDocument', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, containerConfigOverrides: Array<{ __typename?: 'ItemContainerConfigOverrideDocument', shippingConfigCategoryCode: string, sizeUomCode: string, containerCode: string, siteCode: string, maxTraysPerLayer?: number | null, maxLayersPerContainer?: number | null, shipFactor?: number | null, shipMinimum?: number | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetEffectiveIncomeGlAccountQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetEffectiveIncomeGlAccountQuery = { __typename?: 'Query', effectiveIncomeGlAccount: { __typename?: 'EffectiveIncomeGlAccount', rung: Types.MergeDevRevenueRung, conflictingCategoryIds: Array<string>, note: string, account?: { __typename?: 'MergeDevAccountDocument', name: string, accountNumber: string, importId: string, remoteId: string } | null, staleMappings: Array<{ __typename?: 'StaleRevenueMapping', level: Types.MergeDevRevenueRung, accountImportId: string, accountName: string }> } };

export type GetItemsForSelectorQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeCombined?: Types.Scalars['Boolean']['input'];
}>;


export type GetItemsForSelectorQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, itemId: string, erpId: string, name: string, sku: string, upc: string, group: string, sortCategory?: string | null, categories?: Array<string> | null, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveEachesPerUnit?: number | null, absorbedSkus: Array<string>, absorbedUpcs: Array<string>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetItemsWithBaseRateOfSaleQueryVariables = Types.Exact<{
  locationCodes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetItemsWithBaseRateOfSaleQuery = { __typename?: 'Query', itemsWithBaseRateOfSale?: { __typename?: 'ItemsWithBaseRateOfSaleConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, itemId: string, erpId: string, name: string, sku: string, upc: string, group: string, sortCategory?: string | null, categories?: Array<string> | null, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveEachesPerUnit?: number | null, absorbedSkus: Array<string>, absorbedUpcs: Array<string>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type AvailabilityItemsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AvailabilityItemsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, tenantId: string, itemId: string, name: string, sku: string, upc: string, retailPrice?: number | null, cogs?: number | null, status: Types.ItemStatus, description: string, categories?: Array<string> | null, sortCategory?: string | null, history: Array<string>, group: string, erpId: string, availableQuantity?: number | null, genus: string, productGroup: string, isOrganic: boolean, native: boolean, stripeTaxCode?: string | null, usageCount?: number | null, usedForRetail: boolean, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, defaultCarrier?: string | null, defaultShippingConfigCategoryCode?: string | null, shippingConfigCategoryCodes: Array<string>, effectiveShippingUomId?: string | null, inheritedShippingUomIds: Array<string>, availableShippingUomIds: Array<string>, shippingIncrement?: number | null, itemLookupCode: string, taxable: boolean, commissionable: boolean, discountable: boolean, effectiveEachesPerUnit?: number | null, effectiveShippingUomSource: Types.ShippingUomSource, characteristics: Array<{ __typename?: 'ItemCharacteristicPickDocument', itemCharacteristicId: string, valueId: string }>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, substitution?: { __typename?: 'SubstitutionDocument', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfigDocument', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, containerConfigOverrides: Array<{ __typename?: 'ItemContainerConfigOverrideDocument', shippingConfigCategoryCode: string, sizeUomCode: string, containerCode: string, siteCode: string, maxTraysPerLayer?: number | null, maxLayersPerContainer?: number | null, shipFactor?: number | null, shipMinimum?: number | null }> }> | null } | null };

export type GetItemCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetItemCategoriesQuery = { __typename?: 'Query', itemCategories: Array<string> };

export type GetItemSubcategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetItemSubcategoriesQuery = { __typename?: 'Query', itemSubcategories: Array<string> };

export type GetItemGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetItemGroupsQuery = { __typename?: 'Query', itemGroups: Array<string> };

export type GetItemCombinePreviewQueryVariables = Types.Exact<{
  survivorId: Types.Scalars['String']['input'];
  loserId: Types.Scalars['String']['input'];
}>;


export type GetItemCombinePreviewQuery = { __typename?: 'Query', itemCombinePreview: { __typename?: 'ItemCombinePreviewPayload', preview?: { __typename?: 'ItemCombinePreview', survivorId: string, loserId: string, conflictCount: number, survivorSuggested: boolean, fields: Array<{ __typename?: 'ItemCombineField', key: string, label: string, kind: Types.ItemCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean, keepBothAllowed: boolean }>, loserStock: Array<{ __typename?: 'ItemCombineStockRecord', locationId: string, locationName: string, grade: number, quantity: number, allocatedQuantity: number }>, priceLadderConflicts: Array<{ __typename?: 'ItemCombinePriceLadderConflict', priceGroupId: string, priceGroupName: string, priceLevelIds: Array<string> }>, survivorHistory: { __typename?: 'ItemCombineHistory', orderLines: number, invoices: number, customerItems: number, priceLevels: number, kits: number, productionLinks: number }, loserHistory: { __typename?: 'ItemCombineHistory', orderLines: number, invoices: number, customerItems: number, priceLevels: number, kits: number, productionLinks: number } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ItemCombineHistoryCountsFragment = { __typename?: 'ItemCombineHistory', orderLines: number, invoices: number, customerItems: number, priceLevels: number, kits: number, productionLinks: number };

export type GetItemListGroupsQueryVariables = Types.Exact<{
  groupBy: Types.ItemGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetItemListGroupsQuery = { __typename?: 'Query', itemListGroups: Array<{ __typename?: 'ItemGroupBucket', key: string, label: string, count: number }> };

export type GetItemSearchSuggestionQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;


export type GetItemSearchSuggestionQuery = { __typename?: 'Query', itemSearchSuggestion?: string | null };

export type GetItemGlAccountCoverageQueryVariables = Types.Exact<{
  mappedItemsWhere?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  activeItemsWhere?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetItemGlAccountCoverageQuery = { __typename?: 'Query', mappedItems?: { __typename?: 'ItemsConnection', totalCount: number } | null, activeItems?: { __typename?: 'ItemsConnection', totalCount: number } | null };

export type ItemCategoryAssignmentFragment = { __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number };

export type ItemDetailsFragment = { __typename?: 'ItemStateData', batchTracked: boolean, tenantId: string, itemId: string, name: string, sku: string, upc: string, status: Types.ItemStatus, description: string, itemGroup: string, erpId: string, genus: string, productGroup: string, itemLookupCode: string, retailPrice?: number | null, priceLabelId?: string | null, incomeGlAccountId?: string | null, cogs?: number | null, imageUrl?: string | null, programs: Array<string>, characteristics: Array<{ __typename?: 'ItemCharacteristicPickData', itemCharacteristicId: string, valueId: string }>, categoryAssignments: Array<{ __typename?: 'ItemCategoryAssignmentData', code: string, eaches: number }>, notes: Array<{ __typename?: 'ItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, attributes: { __typename?: 'ItemAttributesData', isOrganic: boolean, usedForRetail: boolean, native: boolean, taxable: boolean, stripeTaxCode?: string | null, commissionable: boolean, discountable: boolean, defaultCarrier?: string | null, shippingIncrement?: number | null, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, substitution?: { __typename?: 'Substitution', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, upgrades: Array<{ __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null }> } };

export type ItemUpgradeFieldsFragment = { __typename?: 'ItemUpgrade', upgradeId: string, name: string, categoryLabel?: string | null, isDefault: boolean, isExclusiveInCategory: boolean, status: Types.ItemUpgradeStatus, pricing?: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } | null, cost?: { __typename?: 'ItemUpgradeCost', materialCost?: number | null, labor?: { __typename?: 'LaborMetric', minutes: number, laborTypeCode: string } | null } | null };

export type RoyaltyConfigFragment = { __typename?: 'RoyaltyConfig', rateType: Types.RoyaltyRateType, rate: number, payeeName: string };

export type RoyaltyConfigDocumentFragment = { __typename?: 'RoyaltyConfigDocument', rateType: Types.RoyaltyRateType, rate: number, payeeName: string };

export type ItemSelectorFieldsFragment = { __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, itemId: string, erpId: string, name: string, sku: string, upc: string, group: string, sortCategory?: string | null, categories?: Array<string> | null, shippingConfigCategoryCodes: Array<string>, defaultShippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveEachesPerUnit?: number | null, absorbedSkus: Array<string>, absorbedUpcs: Array<string>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null };

export type ItemSummaryFragment = { __typename?: 'ItemSummaryDocument', batchTracked: boolean, id: string, tenantId: string, itemId: string, name: string, sku: string, upc: string, retailPrice?: number | null, cogs?: number | null, status: Types.ItemStatus, description: string, categories?: Array<string> | null, sortCategory?: string | null, history: Array<string>, group: string, erpId: string, availableQuantity?: number | null, genus: string, productGroup: string, isOrganic: boolean, native: boolean, stripeTaxCode?: string | null, usageCount?: number | null, usedForRetail: boolean, subcategory?: string | null, minShipQty?: number | null, loadFactor?: number | null, weightLbs?: number | null, lengthInches?: number | null, widthInches?: number | null, heightInches?: number | null, containerConfigIds: Array<string>, defaultCarrier?: string | null, defaultShippingConfigCategoryCode?: string | null, shippingConfigCategoryCodes: Array<string>, effectiveShippingUomId?: string | null, inheritedShippingUomIds: Array<string>, availableShippingUomIds: Array<string>, shippingIncrement?: number | null, itemLookupCode: string, taxable: boolean, commissionable: boolean, discountable: boolean, effectiveEachesPerUnit?: number | null, effectiveShippingUomSource: Types.ShippingUomSource, characteristics: Array<{ __typename?: 'ItemCharacteristicPickDocument', itemCharacteristicId: string, valueId: string }>, sizes?: Array<{ __typename?: 'ItemDocumentSize', code: string, eaches: number, uom: number }> | null, substitution?: { __typename?: 'SubstitutionDocument', substitutionType: Types.SubstitutionType, value: string } | null, royalty?: { __typename?: 'RoyaltyConfigDocument', rateType: Types.RoyaltyRateType, rate: number, payeeName: string } | null, containerConfigOverrides: Array<{ __typename?: 'ItemContainerConfigOverrideDocument', shippingConfigCategoryCode: string, sizeUomCode: string, containerCode: string, siteCode: string, maxTraysPerLayer?: number | null, maxLayersPerContainer?: number | null, shipFactor?: number | null, shipMinimum?: number | null }> };

export type GetOrderLineItemShippingUomsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderLineItemShippingUomsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', itemId: string, availableShippingUomIds: Array<string>, defaultShippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, shippingConfigCategoryCodes: Array<string> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetStripeTaxCodesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeTaxCodesQuery = { __typename?: 'Query', stripeTaxCodes: Array<{ __typename?: 'StripeTaxCode', id: string, name: string, description: string }> };

export const ItemCombineHistoryCountsFragmentDoc = new TypedDocumentString(`
    fragment ItemCombineHistoryCounts on ItemCombineHistory {
  orderLines
  invoices
  customerItems
  priceLevels
  kits
  productionLinks
}
    `, {"fragmentName":"ItemCombineHistoryCounts"});
export const ItemCategoryAssignmentFragmentDoc = new TypedDocumentString(`
    fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
    `, {"fragmentName":"ItemCategoryAssignment"});
export const RoyaltyConfigFragmentDoc = new TypedDocumentString(`
    fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}
    `, {"fragmentName":"RoyaltyConfig"});
export const ItemUpgradeFieldsFragmentDoc = new TypedDocumentString(`
    fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}
    `, {"fragmentName":"ItemUpgradeFields"});
export const ItemDetailsFragmentDoc = new TypedDocumentString(`
    fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
    fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}`, {"fragmentName":"ItemDetails"});
export const ItemSelectorFieldsFragmentDoc = new TypedDocumentString(`
    fragment ItemSelectorFields on ItemSummaryDocument {
  batchTracked
  id
  itemId
  erpId
  name
  sku
  upc
  group
  sortCategory
  categories
  sizes {
    code
    eaches
    uom
  }
  shippingConfigCategoryCodes
  defaultShippingConfigCategoryCode
  effectiveShippingUomId
  effectiveEachesPerUnit
  absorbedSkus
  absorbedUpcs
}
    `, {"fragmentName":"ItemSelectorFields"});
export const RoyaltyConfigDocumentFragmentDoc = new TypedDocumentString(`
    fragment RoyaltyConfigDocument on RoyaltyConfigDocument {
  rateType
  rate
  payeeName
}
    `, {"fragmentName":"RoyaltyConfigDocument"});
export const ItemSummaryFragmentDoc = new TypedDocumentString(`
    fragment ItemSummary on ItemSummaryDocument {
  batchTracked
  id
  tenantId
  itemId
  name
  sku
  upc
  retailPrice
  cogs
  status
  description
  categories
  sortCategory
  history
  group
  erpId
  availableQuantity
  genus
  productGroup
  isOrganic
  native
  characteristics {
    itemCharacteristicId
    valueId
  }
  stripeTaxCode
  usageCount
  usedForRetail
  sizes {
    code
    eaches
    uom
  }
  subcategory
  minShipQty
  loadFactor
  weightLbs
  lengthInches
  widthInches
  heightInches
  substitution {
    substitutionType
    value
  }
  royalty {
    ...RoyaltyConfigDocument
  }
  containerConfigIds
  containerConfigOverrides {
    shippingConfigCategoryCode
    sizeUomCode
    containerCode
    siteCode
    maxTraysPerLayer
    maxLayersPerContainer
    shipFactor
    shipMinimum
  }
  defaultCarrier
  defaultShippingConfigCategoryCode
  shippingConfigCategoryCodes
  effectiveShippingUomId
  inheritedShippingUomIds
  availableShippingUomIds
  shippingIncrement
  itemLookupCode
  usageCount
  taxable
  commissionable
  discountable
  effectiveEachesPerUnit
  effectiveShippingUomSource
}
    fragment RoyaltyConfigDocument on RoyaltyConfigDocument {
  rateType
  rate
  payeeName
}`, {"fragmentName":"ItemSummary"});
export const GetItemDocument = new TypedDocumentString(`
    query GetItem($itemId: String!) {
  item(itemId: $itemId) {
    ...ItemDetails
    attributes {
      addedShippingUomIds
      defaultShippingUomId
    }
  }
}
    fragment ItemCategoryAssignment on ItemCategoryAssignmentData {
  code
  eaches
}
fragment ItemDetails on ItemStateData {
  batchTracked
  tenantId
  itemId
  name
  sku
  upc
  status
  description
  itemGroup
  erpId
  genus
  productGroup
  itemLookupCode
  retailPrice
  priceLabelId
  characteristics {
    itemCharacteristicId
    valueId
  }
  incomeGlAccountId
  cogs
  imageUrl
  categoryAssignments {
    ...ItemCategoryAssignment
  }
  programs
  notes {
    context
    text
    submitDate
    submittedBy
  }
  attributes {
    isOrganic
    usedForRetail
    native
    taxable
    stripeTaxCode
    commissionable
    discountable
    defaultCarrier
    shippingIncrement
    subcategory
    minShipQty
    loadFactor
    weightLbs
    lengthInches
    widthInches
    heightInches
    substitution {
      substitutionType
      value
    }
    royalty {
      ...RoyaltyConfig
    }
    containerConfigIds
    shippingConfigCategoryCodes
    defaultShippingConfigCategoryCode
    upgrades {
      ...ItemUpgradeFields
    }
  }
}
fragment ItemUpgradeFields on ItemUpgrade {
  upgradeId
  name
  categoryLabel
  pricing {
    mode
    flatPrice
    markupPercent
  }
  cost {
    materialCost
    labor {
      minutes
      laborTypeCode
    }
  }
  isDefault
  isExclusiveInCategory
  status
}
fragment RoyaltyConfig on RoyaltyConfig {
  rateType
  rate
  payeeName
}`);
export const GetItemDiscountableDocument = new TypedDocumentString(`
    query GetItemDiscountable($itemId: String!) {
  item(itemId: $itemId) {
    attributes {
      discountable
    }
  }
}
    `);
export const GetItemsDocument = new TypedDocumentString(`
    query GetItems($search: String, $where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String, $includeCombined: Boolean! = false) {
  items(
    search: $search
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
    includeCombined: $includeCombined
  ) {
    nodes {
      ...ItemSummary
      incomeGlAccountId
      incomeGlAccount {
        accountNumber
        name
      }
      absorbedItemIds
      absorbedSkus
      absorbedUpcs
      absorbedErpIds
      absorbedLookupCodes
      formerNames
      combinedIntoItemId
      combinedAt
      combinedBy
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RoyaltyConfigDocument on RoyaltyConfigDocument {
  rateType
  rate
  payeeName
}
fragment ItemSummary on ItemSummaryDocument {
  batchTracked
  id
  tenantId
  itemId
  name
  sku
  upc
  retailPrice
  cogs
  status
  description
  categories
  sortCategory
  history
  group
  erpId
  availableQuantity
  genus
  productGroup
  isOrganic
  native
  characteristics {
    itemCharacteristicId
    valueId
  }
  stripeTaxCode
  usageCount
  usedForRetail
  sizes {
    code
    eaches
    uom
  }
  subcategory
  minShipQty
  loadFactor
  weightLbs
  lengthInches
  widthInches
  heightInches
  substitution {
    substitutionType
    value
  }
  royalty {
    ...RoyaltyConfigDocument
  }
  containerConfigIds
  containerConfigOverrides {
    shippingConfigCategoryCode
    sizeUomCode
    containerCode
    siteCode
    maxTraysPerLayer
    maxLayersPerContainer
    shipFactor
    shipMinimum
  }
  defaultCarrier
  defaultShippingConfigCategoryCode
  shippingConfigCategoryCodes
  effectiveShippingUomId
  inheritedShippingUomIds
  availableShippingUomIds
  shippingIncrement
  itemLookupCode
  usageCount
  taxable
  commissionable
  discountable
  effectiveEachesPerUnit
  effectiveShippingUomSource
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetEffectiveIncomeGlAccountDocument = new TypedDocumentString(`
    query GetEffectiveIncomeGlAccount($itemId: String!) {
  effectiveIncomeGlAccount(itemId: $itemId) {
    account {
      name
      accountNumber
      importId
      remoteId
    }
    rung
    conflictingCategoryIds
    staleMappings {
      level
      accountImportId
      accountName
    }
    note
  }
}
    `);
export const GetItemsForSelectorDocument = new TypedDocumentString(`
    query GetItemsForSelector($where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String, $includeCombined: Boolean! = false) {
  items(
    where: $where
    order: $order
    first: $first
    after: $after
    includeCombined: $includeCombined
  ) {
    nodes {
      ...ItemSelectorFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ItemSelectorFields on ItemSummaryDocument {
  batchTracked
  id
  itemId
  erpId
  name
  sku
  upc
  group
  sortCategory
  categories
  sizes {
    code
    eaches
    uom
  }
  shippingConfigCategoryCodes
  defaultShippingConfigCategoryCode
  effectiveShippingUomId
  effectiveEachesPerUnit
  absorbedSkus
  absorbedUpcs
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetItemsWithBaseRateOfSaleDocument = new TypedDocumentString(`
    query GetItemsWithBaseRateOfSale($locationCodes: [String!], $where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String) {
  itemsWithBaseRateOfSale(
    locationCodes: $locationCodes
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...ItemSelectorFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ItemSelectorFields on ItemSummaryDocument {
  batchTracked
  id
  itemId
  erpId
  name
  sku
  upc
  group
  sortCategory
  categories
  sizes {
    code
    eaches
    uom
  }
  shippingConfigCategoryCodes
  defaultShippingConfigCategoryCode
  effectiveShippingUomId
  effectiveEachesPerUnit
  absorbedSkus
  absorbedUpcs
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const AvailabilityItemsDocument = new TypedDocumentString(`
    query availabilityItems($first: Int!, $after: String) {
  items(first: $first, after: $after) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...ItemSummary
    }
  }
}
    fragment RoyaltyConfigDocument on RoyaltyConfigDocument {
  rateType
  rate
  payeeName
}
fragment ItemSummary on ItemSummaryDocument {
  batchTracked
  id
  tenantId
  itemId
  name
  sku
  upc
  retailPrice
  cogs
  status
  description
  categories
  sortCategory
  history
  group
  erpId
  availableQuantity
  genus
  productGroup
  isOrganic
  native
  characteristics {
    itemCharacteristicId
    valueId
  }
  stripeTaxCode
  usageCount
  usedForRetail
  sizes {
    code
    eaches
    uom
  }
  subcategory
  minShipQty
  loadFactor
  weightLbs
  lengthInches
  widthInches
  heightInches
  substitution {
    substitutionType
    value
  }
  royalty {
    ...RoyaltyConfigDocument
  }
  containerConfigIds
  containerConfigOverrides {
    shippingConfigCategoryCode
    sizeUomCode
    containerCode
    siteCode
    maxTraysPerLayer
    maxLayersPerContainer
    shipFactor
    shipMinimum
  }
  defaultCarrier
  defaultShippingConfigCategoryCode
  shippingConfigCategoryCodes
  effectiveShippingUomId
  inheritedShippingUomIds
  availableShippingUomIds
  shippingIncrement
  itemLookupCode
  usageCount
  taxable
  commissionable
  discountable
  effectiveEachesPerUnit
  effectiveShippingUomSource
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetItemCategoriesDocument = new TypedDocumentString(`
    query GetItemCategories {
  itemCategories
}
    `);
export const GetItemSubcategoriesDocument = new TypedDocumentString(`
    query GetItemSubcategories {
  itemSubcategories
}
    `);
export const GetItemGroupsDocument = new TypedDocumentString(`
    query GetItemGroups {
  itemGroups
}
    `);
export const GetItemCombinePreviewDocument = new TypedDocumentString(`
    query GetItemCombinePreview($survivorId: String!, $loserId: String!) {
  itemCombinePreview(survivorId: $survivorId, loserId: $loserId) {
    preview {
      survivorId
      loserId
      fields {
        key
        label
        kind
        survivorValue
        loserValue
        resultValue
        isConflict
        keepBothAllowed
      }
      loserStock {
        locationId
        locationName
        grade
        quantity
        allocatedQuantity
      }
      priceLadderConflicts {
        priceGroupId
        priceGroupName
        priceLevelIds
      }
      survivorHistory {
        ...ItemCombineHistoryCounts
      }
      loserHistory {
        ...ItemCombineHistoryCounts
      }
      conflictCount
      survivorSuggested
    }
    errors {
      code
      message
    }
  }
}
    fragment ItemCombineHistoryCounts on ItemCombineHistory {
  orderLines
  invoices
  customerItems
  priceLevels
  kits
  productionLinks
}`);
export const GetItemListGroupsDocument = new TypedDocumentString(`
    query GetItemListGroups($groupBy: ItemGroupField!, $search: String) {
  itemListGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetItemSearchSuggestionDocument = new TypedDocumentString(`
    query GetItemSearchSuggestion($search: String!) {
  itemSearchSuggestion(search: $search)
}
    `);
export const GetItemGlAccountCoverageDocument = new TypedDocumentString(`
    query GetItemGlAccountCoverage($mappedItemsWhere: ItemSummaryDocumentFilterInput, $activeItemsWhere: ItemSummaryDocumentFilterInput, $first: Int) {
  mappedItems: items(where: $mappedItemsWhere, first: $first) {
    totalCount
  }
  activeItems: items(where: $activeItemsWhere, first: $first) {
    totalCount
  }
}
    `);
export const GetOrderLineItemShippingUomsDocument = new TypedDocumentString(`
    query GetOrderLineItemShippingUoms($where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String) {
  items(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      itemId
      availableShippingUomIds
      defaultShippingConfigCategoryCode
      effectiveShippingUomId
      shippingConfigCategoryCodes
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetStripeTaxCodesDocument = new TypedDocumentString(`
    query GetStripeTaxCodes {
  stripeTaxCodes {
    id
    name
    description
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetItem: build.query<GetItemQuery, GetItemQueryVariables>({
      query: (variables) => ({ document: GetItemDocument, variables })
    }),
    GetItemDiscountable: build.query<GetItemDiscountableQuery, GetItemDiscountableQueryVariables>({
      query: (variables) => ({ document: GetItemDiscountableDocument, variables })
    }),
    GetItems: build.query<GetItemsQuery, GetItemsQueryVariables | void>({
      query: (variables) => ({ document: GetItemsDocument, variables })
    }),
    GetEffectiveIncomeGlAccount: build.query<GetEffectiveIncomeGlAccountQuery, GetEffectiveIncomeGlAccountQueryVariables>({
      query: (variables) => ({ document: GetEffectiveIncomeGlAccountDocument, variables })
    }),
    GetItemsForSelector: build.query<GetItemsForSelectorQuery, GetItemsForSelectorQueryVariables | void>({
      query: (variables) => ({ document: GetItemsForSelectorDocument, variables })
    }),
    GetItemsWithBaseRateOfSale: build.query<GetItemsWithBaseRateOfSaleQuery, GetItemsWithBaseRateOfSaleQueryVariables | void>({
      query: (variables) => ({ document: GetItemsWithBaseRateOfSaleDocument, variables })
    }),
    availabilityItems: build.query<AvailabilityItemsQuery, AvailabilityItemsQueryVariables>({
      query: (variables) => ({ document: AvailabilityItemsDocument, variables })
    }),
    GetItemCategories: build.query<GetItemCategoriesQuery, GetItemCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetItemCategoriesDocument, variables })
    }),
    GetItemSubcategories: build.query<GetItemSubcategoriesQuery, GetItemSubcategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetItemSubcategoriesDocument, variables })
    }),
    GetItemGroups: build.query<GetItemGroupsQuery, GetItemGroupsQueryVariables | void>({
      query: (variables) => ({ document: GetItemGroupsDocument, variables })
    }),
    GetItemCombinePreview: build.query<GetItemCombinePreviewQuery, GetItemCombinePreviewQueryVariables>({
      query: (variables) => ({ document: GetItemCombinePreviewDocument, variables })
    }),
    GetItemListGroups: build.query<GetItemListGroupsQuery, GetItemListGroupsQueryVariables>({
      query: (variables) => ({ document: GetItemListGroupsDocument, variables })
    }),
    GetItemSearchSuggestion: build.query<GetItemSearchSuggestionQuery, GetItemSearchSuggestionQueryVariables>({
      query: (variables) => ({ document: GetItemSearchSuggestionDocument, variables })
    }),
    GetItemGlAccountCoverage: build.query<GetItemGlAccountCoverageQuery, GetItemGlAccountCoverageQueryVariables | void>({
      query: (variables) => ({ document: GetItemGlAccountCoverageDocument, variables })
    }),
    GetOrderLineItemShippingUoms: build.query<GetOrderLineItemShippingUomsQuery, GetOrderLineItemShippingUomsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderLineItemShippingUomsDocument, variables })
    }),
    GetStripeTaxCodes: build.query<GetStripeTaxCodesQuery, GetStripeTaxCodesQueryVariables | void>({
      query: (variables) => ({ document: GetStripeTaxCodesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetItemQuery, useLazyGetItemQuery, useGetItemDiscountableQuery, useLazyGetItemDiscountableQuery, useGetItemsQuery, useLazyGetItemsQuery, useGetEffectiveIncomeGlAccountQuery, useLazyGetEffectiveIncomeGlAccountQuery, useGetItemsForSelectorQuery, useLazyGetItemsForSelectorQuery, useGetItemsWithBaseRateOfSaleQuery, useLazyGetItemsWithBaseRateOfSaleQuery, useAvailabilityItemsQuery, useLazyAvailabilityItemsQuery, useGetItemCategoriesQuery, useLazyGetItemCategoriesQuery, useGetItemSubcategoriesQuery, useLazyGetItemSubcategoriesQuery, useGetItemGroupsQuery, useLazyGetItemGroupsQuery, useGetItemCombinePreviewQuery, useLazyGetItemCombinePreviewQuery, useGetItemListGroupsQuery, useLazyGetItemListGroupsQuery, useGetItemSearchSuggestionQuery, useLazyGetItemSearchSuggestionQuery, useGetItemGlAccountCoverageQuery, useLazyGetItemGlAccountCoverageQuery, useGetOrderLineItemShippingUomsQuery, useLazyGetOrderLineItemShippingUomsQuery, useGetStripeTaxCodesQuery, useLazyGetStripeTaxCodesQuery } = injectedRtkApi;
